import Big from 'big.js';
import { GetChildren, GetLineItems, GetOptions, GetPrices, GetSizes, GetTypes } from 'smg/customer-api/lineitems';
import * as html from 'smg/html';
import { DollarFormat } from 'smg/util';

export default async function main() {
    const $pricing = document.querySelector('#pricing') as HTMLElement;
    const lineItems = await GetLineItems();

    const f = document.createDocumentFragment();

    for (const lineItem of lineItems) {
        const types = await GetTypes(lineItem.name);
        for (const type of types) {
            // lets build pricing tables now with the prices for each line item type,
            // with sizes on the left and quantities on the top

            const table = document.createElement('table');
            table.classList.add('table', 'table-striped', 'table-hover');
            table.style.width = '100%';

            const thead = document.createElement('thead');
            table.appendChild(thead);

            const tbody = document.createElement('tbody');
            table.appendChild(tbody);

            const sizes = await GetSizes(lineItem.name, type.name);

            // we need to know all the possible quantities for all of the sizes of this type
            // so can handle the case where a size has a different quantities than another size

            const qtys = new Set<number>();
            for (const size of sizes) {
                const prices = await GetPrices(lineItem.name, type.name, size.width, size.height, size.type, size.name);
                for (const price of prices) {
                    qtys.add(price.quantity);
                }
            }

            if (qtys.size === 0) {
                continue;
            }

            for (let i = 0; i < sizes.length; i++) {
                const size = sizes[i];
                const prices = await GetPrices(lineItem.name, type.name, size.width, size.height, size.type, size.name);

                if (prices.length === 0) {
                    continue;
                }

                if (i === 0) {
                    const tr = document.createElement('tr');
                    tr.innerHTML = '<th>Size</th>';
                    for (const qty of qtys) {
                        tr.innerHTML += `<th>${qty.toLocaleString()}</th>`;
                    }
                    thead.appendChild(tr);
                }

                const tr = document.createElement('tr');
                tr.innerHTML = `<th>${html.Escape(size.name)}</th>`;
                const pricesMap = new Map<number, Big>();
                for (const price of prices) {
                    pricesMap.set(price.quantity, price.price);
                }
                for (const qty of qtys) {
                    const td = document.createElement('td');
                    const price = pricesMap.get(qty);
                    if (price) {
                        td.textContent = DollarFormat(price);
                    }
                    tr.appendChild(td);
                }
                tbody.appendChild(tr);
            }

            const h2 = document.createElement('h2');
            h2.textContent = `${lineItem.name} - ${type.name}`;
            f.appendChild(h2);

            f.appendChild(table);

            f.appendChild(document.createElement('hr'));
        }
    }

    // now we need to show the pricing for child line items and child line item options.
    // the price for a child line item is only used if the child line item doesn't have any child line item options
    // otherwise if there are child line item options then we need to show the pricing for each child line item option
    // there is not pricing table for child line items or child line item options, just a single price per each

    for (const lineItem of lineItems) {
        const childLineItems = await GetChildren(lineItem.name);

        if (childLineItems.length === 0) {
            continue;
        }

        const h2 = document.createElement('h2');
        h2.textContent = lineItem.name;
        f.appendChild(h2);

        const ul = document.createElement('ul');
        f.appendChild(ul);

        for (const childLineItem of childLineItems) {
            // lets make a list!

            const li = document.createElement('li');
            li.textContent = childLineItem.name;
            ul.appendChild(li);

            const childLineItemOptions = await GetOptions(lineItem.name, childLineItem.name);

            if (childLineItemOptions.length === 0) {
                li.textContent = `${li.textContent ?? ''} - ${DollarFormat(childLineItem.price)}`;
            } else {
                // lets make a sub list!

                const ul2 = document.createElement('ul');
                li.appendChild(ul2);

                for (const childLineItemOption of childLineItemOptions) {
                    const li2 = document.createElement('li');
                    li2.textContent = childLineItemOption.name;
                    ul2.appendChild(li2);

                    li2.textContent = `${li2.textContent ?? ''} - ${DollarFormat(childLineItemOption.price)}`;
                }
            }
        }
    }

    $pricing.innerHTML = '';
    $pricing.appendChild(f);
}